import { Injectable } from '@angular/core';
import { CompanyProfile, PartnerLegacyApiService, UpdateCompanyProfileRequest } from '@galaxy/partner';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { VConfigService } from '../vconfig/vconfig.service';
import { PartnerMailingAddressResponse, PartnerMailingRequest } from './partner';

@Injectable({ providedIn: 'root' })
export class CompanyProfileService {
  private partnerMailingInformation$$: BehaviorSubject<PartnerMailingAddressResponse> =
    new BehaviorSubject<PartnerMailingAddressResponse>(null);

  constructor(
    private vconfigService: VConfigService,
    private partnerLegacyService: PartnerLegacyApiService,
  ) {}

  get partnerMailingInformation$(): Observable<PartnerMailingAddressResponse> {
    return this.partnerMailingInformation$$.asObservable().pipe(filter((mailingInfo) => !!mailingInfo));
  }

  public loadCompanyProfileData(partnerId: string): void {
    const companyProfile = this.partnerMailingInformation$$.getValue();
    if (!companyProfile || companyProfile.pid !== partnerId) {
      this.getPartnerMailingAddress(partnerId);
    }
  }

  public forceLoadCompanyProfileData(partnerId: string): void {
    this.getPartnerMailingAddress(partnerId);
  }

  public getPartnerMailingAddress(partnerId: string): void {
    const mailingFields = [
      'mailing_company_name',
      'mailing_address',
      'mailing_address_2',
      'mailing_city',
      'mailing_country',
      'mailing_state',
      'mailing_postal_code',
      'mailing_phone_number',
      'mailing_email_address',
      'mailing_website_address',
    ];
    this.vconfigService.getConfigurations(partnerId, mailingFields).subscribe((partnerMailingInfo) => {
      partnerMailingInfo.pid = partnerId;
      this.partnerMailingInformation$$.next(partnerMailingInfo);
    });
  }

  public updatePartnerMailingAddress(partnerMailingInfo: PartnerMailingRequest): Observable<any> {
    const companyProfileReq = {
      name: partnerMailingInfo.mailingCompanyName,
      address: partnerMailingInfo.mailingAddress,
      address2: partnerMailingInfo.mailingAddress2,
      city: partnerMailingInfo.mailingCity,
      state: partnerMailingInfo.mailingState,
      country: partnerMailingInfo.mailingCountry,
      postalCode: partnerMailingInfo.mailingPostalCode,
      phoneNumber: partnerMailingInfo.mailingPhoneNumber,
      websiteAddress: partnerMailingInfo.mailingWebsiteAddress,
      emailAddress: partnerMailingInfo.mailingEmailAddress,
    } as CompanyProfile;

    const request = {
      partnerId: partnerMailingInfo.partnerId,
      companyProfileInfo: companyProfileReq,
    } as UpdateCompanyProfileRequest;

    return this.partnerLegacyService.updatePartnerCompanyProfile(request);
  }
}
